var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinutesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.88768 12.9387C1.63049 11.6896 1.00126 10.0526 1 8.41552C0.998743 6.77347 1.62797 5.13141 2.88768 3.87735C5.40333 1.37422 9.48323 1.37422 12.0001 3.87735C14.5158 1.37422 18.5957 1.37422 21.1126 3.87735C22.4491 5.20651 23.0758 6.97372 22.9927 8.71339C22.9185 10.2503 22.2918 11.7647 21.1126 12.9387L12.0001 22L2.88768 12.9387Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11H9L11 8L13 14L15 11H16",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinutesActive);
export default __webpack_public_path__ + "static/media/minutes-active.b9b48859601a32863f0121a24cf90c7e.svg";
export { ForwardRef as ReactComponent };